// extracted by mini-css-extract-plugin
module.exports = {"root":"ProfileButton_root___lwFa","button":"ProfileButton_button__0g2cO","profileSvg":"ProfileButton_profileSvg__GtnyV","profile":"ProfileButton_profile__qiM6M"};